import { RecognizeEventResponse } from '../services/food-analyzer.service';

export const generateFoodHtmlReport = (date: string, inputText: string, items: RecognizeEventResponse[], totals: any) => {
  const itemsHtml = items.map((item, index) => {
    const factor = (item.totalAmount || 0) / 100;
    const nutritionCalculated = item.nutrition ? {
      kcal: (item.nutrition.caloriesPer100 * factor).toFixed(0),
      p: (item.nutrition.proteinPer100 * factor).toFixed(1),
      f: (item.nutrition.fatPer100 * factor).toFixed(1),
      c: (item.nutrition.carbsPer100 * factor).toFixed(1),
      fiber: (item.nutrition.fiberPer100 * factor).toFixed(1),
    } : null;

    return `
      <div style="margin-bottom: 15px; padding: 10px; border: 1px solid #eee; border-radius: 8px;">
        <div style="display: flex; justify-content: space-between; align-items: center;">
          <div style="font-weight: bold; font-size: 1.1em;">${index + 1}. ${item.name || 'Без назви'}</div>
          ${item.originalText ? `<div style="font-size: 0.8em; color: #999; font-style: italic;">"${item.originalText}"</div>` : ''}
        </div>
        <div style="color: #666; font-size: 0.9em;">
          Тип: ${item.type === 'food' ? 'Їжа' : 'Напій'} | 
          Кількість: ${item.totalAmount} ${item.unit || 'г/мл'}
          ${item.portionName ? `(${item.portionCount} x ${item.portionName})` : ''}
        </div>
        ${nutritionCalculated ? `
          <div style="margin-top: 5px; font-weight: 500; color: #2e7d32;">
            Всього: ${nutritionCalculated.kcal} ккал | Б: ${nutritionCalculated.p}г | Ж: ${nutritionCalculated.f}г | В: ${nutritionCalculated.c}г | К: ${nutritionCalculated.fiber}г
          </div>
        ` : '<div style="margin-top: 5px; color: #999;">Нутрієнти не розраховані</div>'}
        
        ${item.nutrition ? `
          <div style="margin-top: 8px; padding: 5px; background: #f9f9f9; border-left: 3px solid #ccc; font-size: 0.85em; color: #555;">
            <span style="font-weight: bold;">База (на 100г/мл):</span>
            Кал: ${item.nutrition.caloriesPer100} | Б: ${item.nutrition.proteinPer100} | Ж: ${item.nutrition.fatPer100} | В: ${item.nutrition.carbsPer100} | К: ${item.nutrition.fiberPer100}
          </div>
        ` : ''}
      </div>
    `;
  }).join('');

  return `
    <!DOCTYPE html>
    <html>
    <head>
      <meta charset="utf-8">
      <title>Звіт про харчування - ${date}</title>
      <style>
        body { font-family: sans-serif; line-height: 1.5; color: #333; max-width: 800px; margin: 40px auto; padding: 20px; }
        h1 { color: #2e7d32; border-bottom: 2px solid #6eb52c; padding-bottom: 10px; }
        h2 { color: #333; border-bottom: 1px solid #eee; padding-bottom: 5px; margin-top: 30px; }
        .totals { background: #e8f5e9; padding: 20px; border-radius: 12px; margin-bottom: 30px; border: 1px solid #6eb52c; }
        .totals-grid { display: grid; grid-template-columns: repeat(auto-fit, minmax(100px, 1fr)); gap: 15px; margin-top: 10px; }
        .total-val { font-size: 1.2em; font-weight: bold; }
        .total-label { font-size: 0.8em; color: #666; text-transform: uppercase; }
        .input-text { background: #f0f0f0; padding: 10px; border-radius: 8px; margin-bottom: 20px; font-style: italic; color: #555; }
        .footer { margin-top: 40px; font-size: 0.8em; color: #999; text-align: center; border-top: 1px solid #eee; padding-top: 20px; }
      </style>
    </head>
    <body>
      <h1>Звіт про харчування</h1>
      <p><strong>Дата:</strong> ${date}</p>
      ${inputText ? `<div class="input-text"><strong>Введений текст:</strong> "${inputText}"</div>` : ''}
      
      <div class="totals">
        <div style="font-weight: bold; text-transform: uppercase; font-size: 0.8em; color: #2e7d32; margin-bottom: 10px;">Загальний підсумок</div>
        <div class="totals-grid">
          <div><div class="total-val">${totals.calories.toFixed(0)}</div><div class="total-label">ккал</div></div>
          <div><div class="total-val">${totals.protein.toFixed(1)}г</div><div class="total-label">Білки</div></div>
          <div><div class="total-val">${totals.fat.toFixed(1)}г</div><div class="total-label">Жири</div></div>
          <div><div class="total-val">${totals.carbs.toFixed(1)}г</div><div class="total-label">Вуглеводи</div></div>
          <div><div class="total-val">${totals.fiber.toFixed(1)}г</div><div class="total-label">Клітковина</div></div>
        </div>
      </div>

      <h2>Детальний список</h2>
      ${itemsHtml}

      <div class="footer">
        Згенеровано системою Everyday | ${new Date().toLocaleString('uk-UA')}
      </div>
    </body>
    </html>
  `;
};
